var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"box"},[_c('header',[_c('h3',[_vm._v(_vm._s(_vm.info.QTitle))])]),_c('div',{staticClass:"cont",domProps:{"innerHTML":_vm._s(_vm.info.AText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }